import { render, staticRenderFns } from "./shopping_cart.vue?vue&type=template&id=2bfc19ab&"
import script from "./shopping_cart.vue?vue&type=script&lang=js&"
export * from "./shopping_cart.vue?vue&type=script&lang=js&"
import style0 from "./shopping_cart.vue?vue&type=style&index=0&id=2bfc19ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports